import { Icon, Link,  Loading } from '@startlibs/components';
import { css } from 'styled-components';
import { formatDate, getColor, media } from '@startlibs/utils';
import { transparentize, lighten } from 'polished';
import React from 'react'
import styled from 'styled-components/macro';

import {useToggle} from '@startlibs/core'
import { dicomDateToDate } from '../../utils';
import { dateMessages } from '../../uploader/lib/utils/dateMessages';

import { UNARCHIVED, UNARCHIVING, UNARCHIVING_FAILED } from '../../utils/utils';
import { UploadStatus } from '../../uploader/panel/RecordItem';

export const RecordItemStyled = styled.div`
  background: #f0f6f8;
  border-radius: 6px;
  position: relative;
  padding: 1rem;
  & ~ & {
    margin-top: 0.75rem;
  }
  ${props => !props.isOnPanel && css`
    padding: 1.5rem;
    margin-top: 1rem;
    ${media.desktop `
      border: 1px solid #cddee3;
      padding: 0.75rem 1.5rem 0.75rem 7rem;
      min-height: 78px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}
  `}
`
export const DicomIcon = styled(Icon).attrs({icon:'dicom'})`
  font-size: 62px;
  position: absolute;
  left: 0;
  width: 7rem;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  ${media.mobile `
    display: none;
  `}
`
export const PatientName = styled.div `
  font-weight: bold;
  font-size: 15px;
  padding-right: 2.5rem;
`
export const RecordDescription = styled.div `
  margin-top: 3px;
  font-size: 13px;
  ${props => !props.isOnPanel && `
    font-size: 12px;
    margin-top: 1px;
  `}
  ${props => props.small && `
    color: rgba(0,0,0,0.5);
    font-size: 11px;
  `}
`
export const Progress = styled.div`
  width: ${props => props.progress || 0}%;
  height: 100%;
  min-width: 4px;
  display: block;
  border-radius: 30px;
  background-color: ${getColor('main')};
  transition: 0.25s linear;
  ${props => props.completed && css`
    background-color: ${getColor('success')};
    width: 100%;
  `}
  ${props => props.failed && css`
    background-color: ${getColor('alert')};
  `}
`

export const UploadedIcon = styled(Icon)`
  font-size: 13px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  padding-top: 1px;
  vertical-align: -2px;
  text-align: center;
  color: white;
  background-color: ${getColor('gray90')};
  display: inline-block;
  margin-right: 0.5rem;
  border-radius: 50%;
  font-weight: bold;
`
export const InlineLoading = styled(Loading)`
  display: inline-block;
  margin-right: 0.5rem;
  vertical-align: -2px;
`
export const WarningIcon = styled(Icon)`
  font-size: 20px;
  line-height: 100%;
  vertical-align: -4px;
  text-align: center;
  color: ${getColor('alert')};
  display: inline-block;
  margin-right: 0.5rem;
` 

export const RemoveRecordIcon = styled(Icon).attrs({icon:'x'})`
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  height: 2.25rem;
  width: 2.25rem;
  text-align: center;
  line-height: 2.25rem;
  border-radius: 50%;
  background: #d9e8ed;
  color: rgba(0,0,0,0.5);
  font-size: 15px;
  cursor: pointer;
  :hover {
    background: ${props => transparentize(0.9, getColor("alert")(props))};
    color: ${getColor('alert')};
  }
  :active {
    background: ${props => transparentize(0.85, getColor("alert")(props))};
    color: ${getColor('alert')};
  }
`
const RemoveConfirmation = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  min-height: 100%;
  background: ${props => lighten(0.5, getColor("alert")(props))};
  padding: 1rem;
  border-radius: 6px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
`

export const UnarchivingItem = ({study, setUnarchivingWorklist, doAction, openLog}) => {

  const canceling = useToggle()
  const studyUid = study.study.iuid;

  return <RecordItemStyled isOnPanel>
      
      <PatientName>{study.patient?.patientName?.trim()}</PatientName>
      {study.study.rotate_status !== UNARCHIVING && <RemoveRecordIcon onClick={() => {
        setUnarchivingWorklist(unarchivingWorklist => unarchivingWorklist.filter(item => item.tools.viewStudyWeblink !== study.tools.viewStudyWeblink))
      }}/>}
      <RecordDescription isOnPanel>{study.study.modalities}{study.study.modalities && " - "}{study.study.studyDescription} {study.study.studyDate && <span className='nowrap'>({formatDate(dicomDateToDate(study.study.studyDate), 'yyyy-MM-dd', dateMessages, true)})</span>}</RecordDescription>
      <UploadStatus>
        <span>
          {study.study.rotate_status === UNARCHIVED && <UploadedIcon icon="check"/>}
          {study.study.rotate_status === UNARCHIVING && <InlineLoading size={14} borderWidth={3}/>}
          {study.study.rotate_status === UNARCHIVING_FAILED && <WarningIcon icon="warning"/>}
          
          {study.study.rotate_status === UNARCHIVED && "Unarchived"}
          {study.study.rotate_status === UNARCHIVING && "Unarchiving"}
          {study.study.rotate_status === UNARCHIVING_FAILED && <span css="color:#C3282D;">Unarchiving failed</span>}
          
        </span>
        <Link  className="link" to={`?page=1&studyStatus=1&forceAll=true&search=${encodeURIComponent(studyUid)}`}>Show study</Link> 

      </UploadStatus>
  </RecordItemStyled>
}